// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BaseValidationError{min-height:22px;overflow:hidden;padding-bottom:4px}.BaseValidationError span{font-family:\"Open Sans\",sans-serif}.BaseValidationError.is-small{min-height:10px}.BaseValidationError__message{display:block;opacity:0;transition:all .2s cubic-bezier(.44,.13,.31,1.23);transform:translateY(-100%)}.BaseValidationError.is-active .BaseValidationError__message{opacity:1;transform:translateY(4px)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
